import { TextLabel } from "@/components/r3f/renderers/text-label";
import { blue, CircularProgress, cyan } from "@faro-lotv/flat-ui";
import { Stack } from "@mui/system";
import { MutableRefObject, type JSX } from "react";
import { NewWaypoint } from "./new-waypoints-store";
import { UploadingWaypoint } from "./use-currently-updating-waypoints";

type NewWaypointLoadingIndicatorProps = {
  /** The waypoint to show the label for. */
  waypoint: NewWaypoint | UploadingWaypoint;

  /** The element containing the text label. */
  parentRef: MutableRefObject<HTMLElement>;
};

/** @returns a label displaying an uploading waypoint indicator. */
export function NewWaypointLoadingIndicator({
  waypoint,
  parentRef,
}: NewWaypointLoadingIndicatorProps): JSX.Element {
  return (
    <TextLabel
      index={0}
      position={waypoint.worldPosition}
      parentRef={parentRef}
      visible
      active
      activeCursor="pointer"
      transparent
      placement="bottom"
      backgroundColor={blue[800]}
      padding={0.25}
      fontSize="0.625em"
      pointerEvents="none"
    >
      <Stack direction="row" sx={{ gap: 0.5, alignItems: "center" }}>
        <CircularProgress size={10} sx={{ color: cyan[400] }} />
        Importing {"type" in waypoint ? waypoint.type : "image"}
        {waypoint.files.length > 1 ? "s" : ""}...
      </Stack>
    </TextLabel>
  );
}
